import { getPreviousDate } from "../components/utils/dateFormate";
import apiService from "./api";

export const devicePlatformService = async (domainName,  date = getPreviousDate(), limit=5, page = 1,isRegistered=false,token) => {
    const url = `/api/v1/admin/get-device-list?limit=${limit}&pageNo=${page}&domain=${domainName}&startDate=${date}&isRegistered=${isRegistered}`;
    console.log("thi is usrl", url);
    
    try {
        const response = await apiService.get(url, {}, token);
        return response.data

    } catch (error) {
        throw error;
    }
}